import { resolveApiBaseUrl } from "../utils/apiBase.util";

/** Resolved at call time so staging builds use the browser admin host + `/nodeapi`. */
export const getApiBaseUrl = () => resolveApiBaseUrl();